import Typography from 'components/global/Typography';

import * as S from './Tabs.styled';

const BaseForm = ({ title, children }) => {
	return (
		<S.StyledContainer>
			<S.SectionTitle>
				<Typography variant="p2" fontWeight="700">
					{title}
				</Typography>
			</S.SectionTitle>
			{children}
		</S.StyledContainer>
	);
};

export default BaseForm;
